import { UserPlus, Search, Heart } from "lucide-react"

const steps = [
  {
    id: 1,
    title: "Create Your Profile",
    description:
      "Share your details and preferences to help us understand your unique personality and what you're looking for in a partner.",
    icon: UserPlus,
    color: "from-rose-500 to-pink-600",
  },
  {
    id: 2,
    title: "Discover Matches",
    description:
      "Our smart algorithms and personalized suggestions connect you with compatible partners who share your values and goals.",
    icon: Search,
    color: "from-pink-500 to-purple-600",
  },
  {
    id: 3,
    title: "Build a Relationship",
    description:
      "With continuous guidance and support from the TACTOS community, take the next step in building a lasting, meaningful relationship.",
    icon: Heart,
    color: "from-purple-500 to-indigo-600",
  },
]

export default function HowItWorks() {
  return (
    <section className="py-10 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-3xl font-bold mb-4">
            How{" "}
            <span className="bg-gradient-to-r from-rose-600 to-pink-600 bg-clip-text text-transparent">It Works</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Simple steps to find your perfect life partner</p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-16 left-1/2 transform -translate-x-1/2 w-full max-w-4xl">
            <div className="relative h-1 bg-gradient-to-r from-rose-200 via-pink-200 to-purple-200 rounded-full">
              <div className="absolute inset-0 bg-gradient-to-r from-rose-400 via-pink-400 to-purple-400 rounded-full animate-pulse opacity-50"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10">
            {steps.map((step, index) => {
              const Icon = step.icon
              return (
                <div key={step.id} className="text-center group">
                  {/* Step Number & Icon */}
                  <div className="relative mb-8">
                    <div
                      className={`w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br ${step.color} flex items-center justify-center shadow-xl group-hover:scale-105 transition-transform duration-300`}
                    >
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <div className="absolute -top-1 -right-1 w-6 h-6 bg-white rounded-full border-2 border-gray-100 flex items-center justify-center shadow">
                      <span className="text-xs font-bold text-gray-700">{step.id}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="space-y-3">
                    <h3 className="text-lg md:text-xl font-semibold text-gray-900">{step.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed max-w-xs mx-auto">{step.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
